import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleOverlay } from '../../Slices/OverlaySlice';

const Overlay = ({ id, children }) => {
  const isOpen = useSelector((state) => state.overlaySlice.overlays[id]);
  const dispatch = useDispatch();

  if (!isOpen) {
    return null;
  }

  return (
    <div className="overlay" onClick={() => dispatch(toggleOverlay(id))}>
      <div className="overlay__content" onClick={(e) => e.stopPropagation()}>
        <div className="overlay__header">
          <button
            onClick={() => dispatch(toggleOverlay(id))}
            className="overlay__close"
          >
            <div className="icon-close"></div>
          </button>
        </div>
        <div className="overlay__body">{children}</div>
      </div>
    </div>
  );
};

export default Overlay;
